<template>
<v-container fluid>
  <page-header>
    <v-breadcrumbs>
      <v-breadcrumbs-item :to="{name: 'Users'}">Users</v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :disabled="true">{{user.firstName}} {{user.lastName}}</v-breadcrumbs-item>
    </v-breadcrumbs>
  </page-header>
  <v-card class="pb-5">
    <v-card-title>
      User Profile
    </v-card-title>
    <v-card-text>
  <v-form v-if="user" ref="form" autocomplete="off">
    <v-row>
      <v-col cols="12" lg="6">
        <v-text-field
          v-model="user.firstName"
          label="First Name"
          :rules="[rules.required]"
        />
      </v-col>
      <v-col cols="12" lg="6">
        <v-text-field
          v-model="user.lastName"
          label="Last Name"
          :rules="[rules.required]"
        />
      </v-col>
    </v-row>
    <div v-if="user.id">
      <v-switch v-model="editPassword" label="Edit Password" />
    </div>
    <div v-if="editPassword">
      <v-text-field
        type="password"
        v-model="user.password"
        label="Password"
        :rules="[rules.passwordRule]"
      />
      <v-text-field
        type="password"
        v-model="user.confirmPassword"
        label="Confirm Password"
        :rules="[rules.passwordMatched(user.password, user.confirmPassword)]"
      />
    </div>
    <v-text-field v-model="user.username" label="User Name" />
    <v-text-field v-model="user.email" label="Email" :rules="[rules.emailMatch]" />
    <v-text-field
      v-mask="'+1(###) ###-####'"
      v-model="user.phone"
      label="Phone Number"
    />

    <v-select
      v-model="user.locations"
      multiple
      chips
      label="Authorized Locations"
      :items="account.locations"
      item-text="name"
      item-value="id"
    />
    <v-checkbox v-model="user.internalUser" label="Internal User" />
  </v-form>
    </v-card-text>
    <v-card-actions>
        <v-spacer/>
      <v-btn @click="updateUserProfile" :loading="isAppLoading" :disabled="isAppLoading">
        Update
      </v-btn>
        <v-spacer/>
    </v-card-actions>
  </v-card>

  <v-card class="mt-10 pb-5">
    <v-card-title>
      Accessible Modules
    </v-card-title>
    <v-card-text>
      <v-select v-model="userModules" label="User's module" multiple chips :items="availableModules" item-text="name" item-value="id"/>
    </v-card-text>
    <v-card-actions>
        <v-spacer/>
      <v-btn @click="updateUserModules" :loading="isAppLoading" :disabled="isAppLoading">
        Update
      </v-btn>
        <v-spacer/>
    </v-card-actions>
  </v-card>
    
  <v-card class="mt-10 pb-5">
    <v-card-title>
      User Roles
    </v-card-title>
    <v-card-text>
      <v-select v-model="userRoles" label="User roles" multiple chips :items="groupedRoles" item-text="name" item-value="id"/>
    </v-card-text>
    <v-card-actions>
        <v-spacer/>
      <v-btn @click="updateUserRoles" :loading="isAppLoading" :disabled="isAppLoading">
        Update
      </v-btn>
        <v-spacer/>
    </v-card-actions>
  </v-card>

</v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import { rules } from "@/store/util/rules.js";
import PageHeader from "../components/common/PageHeader.vue";
import { getAccountModules } from '@/services/module'

export default {
  directives: { mask },
  data: () => ({
    account: null,
    editPassword: false,
    user: null,
    userModules: [],
    availableModules: [],
    userRoles: [],
    availableRoles: [],
    rules,
  }),
  watch: {
    editPassword(val) {
      if (this.user) {
        this.user.changePassword = val;
      }
    },
  },
  components: {
    PageHeader,
  },
  computed: {
    ...mapGetters("navigation", ["navState", "isAppLoading", "globalCenter"]),
    groupedRoles(){
      if(this.availableRoles){
       const grouped = [... this.availableRoles];
       grouped.sort( (r1, r2 ) => r1.moduleName > r2.moduleName);
        return grouped;
      }
      else{
        return []
      }
    }
  },
  methods: {
    ...mapActions("messages", ["addErrorMessage", "addSuccessMessage"]),
    async initUser() {
      const userId = this.$route.params.id;
      if (userId) {
        const params = {
          userId,
        };
        return await this.$axios
          .get("user/get-by-id", { params })
          .then((resp) => {
            return resp.data;
          });
      }
    },
    loadUserModules() {
      this.$axios("/user/module", { params: { user_id: this.user.id } }).then(
        (resp) => {
          const userMods = resp.data;
          if (userMods) {
            this.userModules = userMods.map((m) => m.id);
          }
        }
      );
    },
    async loadAccountModules() {
      const params = { 
        pageIndex: 1,
        pageSize: 100
      }
      return await getAccountModules(params).then((resp) => {
        this.availableModules = resp.data.content;
        return this.availableModules;
      });
    },
    loadUserRoles() {
      this.$axios("/user/roles", { params: { user_id: this.user.id } }).then(
        (resp) => {
          const userRoles = resp.data;
          if (userRoles) {
            this.userRoles = userRoles.map((m) => m.id);
          }
        }
      );
    },
    async loadAccountRoles() {
      return await this.$axios("/account/get-roles").then((resp) => {
        this.availableRoles = resp.data;
        this.availableRoles.forEach(r => {
          const moduleName = this.availableModules.find( m => m.id == r.moduleId).name; 
          r.moduleName = moduleName ? moduleName:'All Modules';
        })
        return this.availableRoles;
      });
    },
    async initAccount() {
      return await this.$axios
        .get("/account/get-by-id", {
          params: { accountId: this.globalCenter.accountId },
        })
        .then((resp) => {
          return resp.data;
        })
        .catch(() => {
          this.addErrorMessage("Error loading account from server");
        });
    },
    updateUserModules() {
      console.log("updating user module...");
      const data = {
        userId: this.user.id,
        moduleIds: this.userModules ? this.userModules : [],
      };
      this.$axios.post("/user/module", data).then(() => {
        this.addSuccessMessage("User modules updated");
      });
    },
    updateUserRoles() {
      console.log("updating user roles...");
      const data = {
        userId: this.user.id,
        roleIds: this.userRoles ? this.userRoles : [],
      };
      this.$axios.post("/user/role", data).then(() => {
        this.addSuccessMessage("User roles updated");
      });
    },
    updateUserProfile() {
      console.log("updating user profile...");
      if (!this.$refs.form.validate()) {
        this.addErrorMessage("Please check all required fields are entered");
        return;
      }

      const postData = Object.assign({}, this.user);
      if (this.user && this.user.id) {
        postData["userId"] = this.user.id;
      }

      if (this.user.locations) {
        postData.locations = this.user.locations.map((l) => l.id || l);
      }

      this.$axios
        .post("/account/account-provision-user", postData)
        .then((resp) => {
          this.user = resp.data;
          this.addSuccessMessage("User updated");
        })
        .catch((error) => {
          this.addErrorMessage(error.message || "Error updating user");
        });
    },
  },
  mounted() {
    this.initUser().then((user) => {
      this.user = user;
      if (this.user) {
        this.editPassword = this.user && this.user.id ? false : true;
        this.user.changePassword = this.editPassword;

        this.initAccount().then((account) => {
          this.account = account;
        });

        this.loadAccountModules().then((allModules) => {
          console.log(allModules);
          this.loadUserModules();
        });

        this.loadAccountRoles().then((allRoles) => {
          console.log(allRoles);
          this.loadUserRoles();
        });
      }
    });
  },
};
</script>
